import React from "react"
import { useTranslation } from "react-i18next";
import { useStateContext } from "../../context/ContextProvider";
import {IoIosArrowDown} from "../utils/icons"
export const Label = ({value,onChange,required,labelText,type ,name})=>{
  const { t } = useTranslation();
  return(
<div class="relative w-full my-4">
    <input type={type} id={labelText} class="block px-2.5 pb-2.5 pt-4 w-full body-1 text-tcolor-5  dark:text-tcolor-2 bg-n-1  dark:bg-back-darksecondary rounded-lg border border-back-darktertiary/50  dark:border-n-1/50 appearance-none  focus:outline-none focus:ring-0 focus:border-color-1 peer" placeholder=" " 
    value={value}
    onChange={onChange}
    required={required}

    name={name}
    />
    <label for={labelText} class="absolute text-sm text-tcolor-5  dark:text-tcolor-2 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-n-1 dark:bg-back-darksecondary  px-2 peer-focus:px-2 peer-focus:text-color-1 dark:peer-focus:text-tcolor-2  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:bg-n-1  peer-focus:dark:bg-back-darksecondary peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 body-1">{t(labelText)}</label>
</div>
    )
}
export const DLabel = ({value,onChange,required,labelText,type ,name})=>{
  const { t } = useTranslation();
  return(
<div class="relative w-full my-4">
    <input type={type} id={labelText} class="block px-2.5 pb-2.5 pt-4 w-full body-1 text-tcolor-5  bg-n-1   rounded-lg border border-back-darktertiary/50  appearance-none  focus:outline-none focus:ring-0 focus:border-color-1 peer" placeholder=" " 
    value={value}
    onChange={onChange}
    required={required}

    name={name}
    />
    <label for={labelText} class="absolute text-sm text-tcolor-5  duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-n-1   px-2 peer-focus:px-2 peer-focus:text-color-1  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:bg-n-1  peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 body-1">{t(labelText)}</label>
</div>
    )
}


export const TextArea = ({value,onChange,required,labelText,name,type,row})=>{
  const { t } = useTranslation();
  return(
<div class="relative w-full my-4">
    <textarea type="text" id={labelText} class="block px-2.5 pb-2.5 pt-4 w-full body-1 text-n-2 bg-n-8 rounded-lg border  border-n-1/50 appearance-none  focus:outline-none focus:ring-0 focus:border-color-1 peer" placeholder=" " 
    value={value}
    onChange={onChange}
    required={required}
    name={name}
    row={row}

    />
    <label for={labelText} class="absolute text-sm text-gray-500  duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-n-8  px-2 peer-focus:px-2 peer-focus:text-color-1  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:bg-n-8 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 body-1">{t(labelText)}</label>
</div>
    )
}

export const Select = ({value,setValue,required,labelText,name,Data})=>{
  const { t } = useTranslation();
  const {currentDir}=useStateContext()
  return(
<div class="relative bg-n-1  w-full my-4">
<label for={labelText} className="block mb-2 text-sm font-medium font-kufi text-tcolor-5  body-1">{t(labelText)}</label>
    <select 
     className="bg-n-1  font-kufi border border-back-darktertiary/50    focus:outline-none focus:ring-0 focus:border-color-1 peer 0 text-tcolor-5   text-sm rounded-lg focus:ring-color-1 body-1 block w-full p-3"
  
    value={value}
    onChange={(e)=>setValue(e.target.value)}
    required={required}
    name={name}
    >"
    <option selected className=""></option>
    {Data?.map((data)=>
               <option value={currentDir === "ltr" ? data._id :data._id}>
          {t(currentDir == "ltr" ? data.titleEn :data.titleAr)}
          </option>
    )}

   
        </select>
</div>
    )
}

  
export const Spiner=({fillColor})=>(
  <div role="status">
      <svg aria-hidden="true"  className={`w-5 h-5 text-n-2 animate-spin mx-2 dark:text-gray-600 ${fillColor ? fillColor :  "dark:fill-n-1 fill-color-1"}  `} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
      </svg>
  </div>
  
        )

export const SpinButton = ({ className,onClick, children, px, white,isLoading ,textColor ,borderColor ,fillColor}) => {
  const classes = ` flex  flex-row font-kufi py-2 px-4 rounded-xl hover:bg-gray-100 bg-white border ${borderColor ? borderColor :"border-color-1  dark:border-gray-200"}  focus:ring-4 focus:outline-none  focus:ring-gray-100 dark:focus:ring-gray-600 dark:bg-back-darktertiary dark:border-gray-700 ${textColor ? textColor :"dark:text-white  text-color-1" }  ${className || ""}`;
  const spanClasses = "relative z-10";


      
    const renderButton = () => (
    <button className={`${classes} ${isLoading ? "px-3":" px-7" }`} type="submit"
    onClick={onClick ? onClick : null} 
    >
      <span className={spanClasses}>{children}</span>
      {isLoading && <Spiner fillColor={fillColor}/>}
    </button>
  );

  return renderButton();
};



export const DSpinButton = ({ className,onClick, children, px, white,isLoading ,textColor ,borderColor,fillColor ,bgColor}) => {
  const classes = ` flex  flex-row font-kufi py-2 px-4 rounded-xl hover:bg-gray-100 ${ bgColor ? bgColor : "bg-white"}  border ${borderColor ? borderColor :"border-color-1 "}  focus:ring-4 focus:outline-none  focus:ring-gray-100  ${textColor ? textColor :" text-color-1" }  ${className || ""}`;
  const spanClasses = "relative z-10";

  
 const Spiner=()=>(
<div role="status">
    <svg aria-hidden="true"  className={`w-5 h-5 text-n-2 animate-spin mx-2  ${fillColor ? fillColor :  " fill-color-1"}  `} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
</div>

      )
      
    const renderButton = () => (
    <button className={`${classes} ${isLoading ? "px-3":" px-7" }`} type="submit"
    onClick={onClick ? onClick : null} 
    >
      <span className={spanClasses}>{children}</span>
      {isLoading && <Spiner/>}
    </button>
  );

  return renderButton();
};




